import React from "react";
import "./home.css";

const Home = () => {
  return (
    <div className="home">
      <div className="align-center">
        <h1 className="home-head">TravelPreneur NJ</h1>
        <hr />
        <p className="home-para">Zindagi Na Milegi dubara!</p>
      </div>
    </div>
  );
};

export default Home;
